'use strict';
const svgMarkupBuilder = require('./markup-builder').svgMarkupBuilder,
	dashes = require('@mindmup/mapjs-core/src/theme/line-strokes'),
	scaleDashes = require('@mindmup/mapjs-core/src/util/scale-dashes');
module.exports = function writeConnector(pathInfo, fromArrowMarkerId, toArrowMarkerId) {
	const g = svgMarkupBuilder('g').attr('transform', 'translate(' + pathInfo.position.left + ',' + pathInfo.position.top + ')'),
		mainLineAttributes = {
			'd': pathInfo.d,
			'stroke-dasharray': scaleDashes(dashes[pathInfo.lineStyle], pathInfo.width),
			stroke: pathInfo.color,
			'stroke-width': pathInfo.width,
			'stroke-linecap': 'round'
		};
	if (fromArrowMarkerId) {
		mainLineAttributes['marker-start'] = 'url(#' + fromArrowMarkerId  + ')';
	}
	if (toArrowMarkerId) {
		mainLineAttributes['marker-end'] = 'url(#' + toArrowMarkerId + ')';
	}
	svgMarkupBuilder('path').attr(mainLineAttributes).appendTo(g);
	if (pathInfo.afterArrowD) {
		svgMarkupBuilder('path').attr(
			{
				'd': pathInfo.afterArrowD,
				'stroke-dasharray': scaleDashes(dashes[pathInfo.lineStyle], pathInfo.width),
				stroke: pathInfo.color,
				'stroke-width': pathInfo.width,
				'stroke-linecap': 'round'
			}).appendTo(g);
	}
	return g;
};


